import FormRow from 'components/forms/FormRow';
import DateInput from 'components/forms/inputs/rhf-inputs/DateInput';
import SelectInput from 'components/forms/inputs/rhf-inputs/SelectInput';
import TextInput from 'components/forms/inputs/rhf-inputs/TextInput';
import { getValidOptionsFromClassifier } from 'utils/formUtil';
import { ContactFormState } from './useContactForm';

/** Identity document: a person's document number, dates, issuing country and authority. */
export const IdentityDocumentFields = ({ form }: { form: ContactFormState }): JSX.Element => {
    const { control, setValue } = form.methods;
    const { classifiers } = form;

    return (
        <>
            <TextInput
                name="identityDocumentNumber"
                control={control}
                label="contacts.identity-document.number"
                placeholder="contacts.identity-document.number"
            />
            <FormRow>
                <DateInput
                    name="identityDocumentDateOfIssue"
                    control={control}
                    label="contacts.identity-document.date-of-issue"
                />
                <DateInput
                    name="identityDocumentDateOfExpiry"
                    control={control}
                    label="contacts.identity-document.date-of-expiry"
                />
            </FormRow>
            <FormRow>
                <SelectInput
                    setValue={setValue}
                    control={control}
                    label="contacts.identity-document.issuing-country"
                    name="identityDocumentIssuingCountryCode"
                    options={getValidOptionsFromClassifier<string, string>(classifiers['COUNTRY']) ?? []}
                    getOptionLabel="label"
                    getOptionIdentifier="value"
                    placeholder="contacts.identity-document.issuing-country"
                    sortDirection="asc"
                />
                <TextInput
                    name="identityDocumentIssuingAuthority"
                    control={control}
                    label="contacts.identity-document.issuing-authority"
                    placeholder="contacts.identity-document.issuing-authority"
                />
            </FormRow>
        </>
    );
};
